export default {
  continueAs: 'Lanjutkan sebagai',
  individual: 'Individu',
  corporate: 'Korporat',
  agreeTermsIntro: 'Dengan memilih salah satu opsi tes Anda telah setuju dengan',
  agreeTerms: 'Saya setuju dengan',
  and: 'dan',
  privacyPolicy: 'Kebijakan Privasi',
  termsCondition: 'Syarat dan Ketentuan',
  personalInfo: 'Informasi Pribadi',
  settings: 'Pengaturan',
  language: 'Bahasa',
  priadi: 'PRiADI',
  carousel: {
    scientificObjective: 'Ilmiah & Objektif',
    scientificObjectiveDesc: 'Berdasarkan penelitian dermatoglik. Valid & Terpercaya.',
    biasFree: 'Bebas Bias',
    biasFreeDesc: 'Tidak dipengaruhi oleh suasana hati, manipulasi, atau latar belakang budaya.',
    allAges: 'Semua Usia',
    allAgesDesc: 'Berlaku dari bayi hingga dewasa, mengungkapkan trait yang stabil.',
    veryComprehensive: 'Sangat Komprehensif',
    veryComprehensiveDesc: 'Memetakan lebih dari 50 karakteristik inheren. Disajikan dalam 75+ halaman analisis.',
    easyToUnderstand: 'Mudah Dipahami',
    easyToUnderstandDesc: 'Laporan tes mudah dipahami. Spektrum warna mewakili tingkat performa yang diprediksi.',
    multiLanguages: 'Multi Bahasa',
    multiLanguagesDesc: 'Tersedia dalam berbagai bahasa: Inggris, Mandarin, Hindi, Indonesia, Jepang, Korea, Arab, Rusia & Melayu.',
  },
  welcome: 'Selamat datang di @:priadi',
  loginPageSubtitle: 'Login menggunakan @:email dan @:password Anda',
  email: 'Email',
  emailHint: 'Masukan alamat email Anda',
  password: 'Kata sandi',
  passwordHint: 'Masukan kata sandi Anda',
  fullname: 'Nama lengkap',
  fullnameHint: 'Masukan nama lengkap Anda',
  rePassword: 'Konfirmasi kata sandi',
  rePasswordHint: 'Masukan kembali kata sandi Anda',
  phone: 'Nomor telepon',
  phoneHint: 'Masukan nomor telepon Anda',
  birthdate: 'Tanggal lahir',
  birthdateHint: 'Masukan tanggal lahir Anda',
  signup: 'Daftar',
  signin: 'Login',
  signout: 'Keluar',
  signupText: 'Untuk membuat akun, silahkan isi formulir di bawah ini',
  noaccount: 'Belum punya akun?',
  hasAccount: 'Sudah punya akun?',
  greeting: 'Halo',
  sloganHome: 'Buka potensi diri sejati Anda:',
  sloganHomeSubtitle: 'Temukan jati diri bersama PRiADI Psychological Fingerprints',
  testPackage: 'Paket Tes',
  promo: 'Kode Referal / Promo',
  freeConsult: 'Gratis konsultasi',
  noConsult: 'Tanpa konsultasi',
  submit: 'Kirim',
  contactUs: 'Kontak kami',
  callCenter: 'Call Center',
  voucherCodeText: 'Dapatkan harga spesial dengan memasukan kode promo pada kolom di bawah ini',
  voucherCodeHint: 'Masukan kode promo di sini',
  invalidReferralCode: 'Kode referral tidak valid. Mohon periksa kode Anda.',
  validReferralCode: 'Kode referral diterima! Anda mendapatkan diskon.',
  referralCodeError: 'Kode referral tidak memberikan diskon apapun.',
  codeApplied: 'Kode promo berhasil diterapkan!',
  codeInvalid: 'Kode promo tidak valid atau tidak dikenali.',
  features: 'Fitur',
  includeConsultation: 'Sertakan sesi konsultasi',
  selectPackage: 'Pilih Paket',
  selectCounselor: 'Pilih konselor',
  selectedCounselor: 'Konselor terpilih',
  consultationType: 'Tipe konsultasi',
  counselorName: 'Nama konselor',
  counselorFee: 'Biaya konsultasi',
  contactAvailability: 'Mohon hubungi call center PRiADI untuk mengetahui ketersediaan konselor',
  free: 'Gratis',
  selectCounselorFirst: 'Silakan pilih konselor terlebih dahulu',
  cancel: 'Batal',
  total: 'Jumlah',
  continue: 'Lanjutkan',
  online: 'Online',
  offline: 'Offline',
  note: 'catatan',
  satisfiedClient: 'klien terbantu',
  edit: 'Ubah',
  success: 'Sukses',
  redirectLogin: 'Mengarahkan ke halaman login',
  validation: {
    required: '{field} tidak boleh kosong.',
    minLength: '{field} setidaknya mengandung {min} karakter.',
    passwordMismatch: 'Kata sandi tidak sama.',
    minLowercase: '{field} setidaknya mengandung {min} huruf kecil',
    minUppercase: '{field} setidaknya mengandung {min} huruf kapital',
    minNumeric: '{field} setidaknya mengandung {min} nomor',
    minSymbol: '{field} setidaknya mengandung {min} simbol',
  },
  transaction: 'Transaksi',
  testResult: 'Hasil tes',
  testResultMsg: {
    empty: 'Tidak ada hasil tes tersedia',
    email: 'Hasil tes akan dikirimkan via email',
    corporate: 'Mohon hubungi penyelenggara tes terkait hasil tes',
  },
  validUntil: 'Berlaku hingga',
  takeATest: 'Tes Sekarang',
  checkout: 'Checkout',
  testDone: 'Selesai',
  checkoutQuestion: 'Yakin untuk checkout?',
  checkoutFailed: 'Terjadi error saat checkout',
  confirmation: {
    title: 'Konfirmasi',
    prompt: 'Anda yakin? {optional}',
    yes: 'Ya',
    no: 'Tidak',
    cancel: 'Batal',
    back: 'Kembali',
    next: 'Selanjutnya',
  },
  testMethod: 'Metode tes',
  chooseOne: 'Pilih salah satu',
  liveCapture: {
    title: 'Foto Jari',
    subtitle: 'Ambil kesepuluh gambar jari Anda secara langsung menggunakan kamera.',
  },
  uploadFinger: {
    title: 'Unggah gambar jari',
    subtitle: 'Unggah kesepuluh gambar jari Anda pada formulir yang disediakan',
    tutorialTitle: 'Sebelum melanjutkan',
    tutorialSubtitle: 'Mohon simak tatacara di bawah ini',
    retake: 'Ingin mengambil ulang?',
    retakeTitle: 'Ambil ulang',
    retakeConfirm: 'Ya, ambil ulang',
    retakeCancel: 'Tidak',
    finish: 'Selesai',
    leftHand: 'Tangan Kiri',
    rightHand: 'Tangan Kanan',
    continuePayment: 'Lanjutkan ke pembayaran',
    continueTransaction: 'Kembali ke daftar transaksi',
    continueTakeAnother: 'Ambil tes lainnya',
    progress: '{count} dari 10 berhasil diunggah',
    tapToRetake: 'Ketuk jari yang sudah diunggah untuk mengambil ulang',
  },
  isRecommended: 'Sangat direkomendasikan',
  bottomNav: {
    home: 'Beranda',
    transaction: 'Transaksi',
    profile: 'Profil Saya',
    callCenter: 'Call Center',
  },
  changePassword: {
    title: 'Ubah kata sandi',
    subtitle: 'Masukkan kata sandi lama dan baru Anda di bawah ini',
    newPassword: 'Kata sandi baru',
    oldPassword: 'kata sandi lama',
  },
  externalLink: {
    prompt: 'Anda akan diarahkan ke tautan eksternal',
  },
  createTransaction: {
    title: 'Tambah Transaksi',
    subtitle: 'Lengkapi formulir di bawah ini untuk melanjutkan',
  },
  reset: 'Mulai ulang',
  saved: 'Tersimpan',
  failed: 'Gagal',
  noTransaction: 'Belum ada transaksi',
  guessModalText: 'Untuk pengalaman maksimal, silakan login. Atau, Anda dapat melanjutkan sebagai tamu.',
  continueAsGuest: 'Lanjutkan sebagai tamu',
  or: 'atau',
  capture: {
    beforeProceeding: 'Sebelum Melanjutkan,',
    watchTutorial: 'Simak terlebih dahulu tutorial singkat dibawah ini:',
    pleasWait: 'Mohon tunggu',
    seconds: 'detik',
    takeFinger: 'Ambil Sidik Jari',
    finish: 'Selesai',
    fingerGuide: 'Petunjuk Foto Sidik Jari',
    continue: 'Lanjutkan',
  },
  payment: {
    title: 'Konfirmasi Pembayaran',
    amountToPay: 'Jumlah yang harus dibayarkan :',
    bankInfo: 'BNI 353664685 A/N Dedi Priadi',
    uploadProof: '*mohon upload bukti transfer agar data dapat segera diproses.',
    uploadButton: 'Upload Bukti Transfer',
    importantInfo: 'Informasi penting',
    paymentInstructions: [
      'Lakukan pembayaran sesuai dengan nominal yang tertera ke rekening yang tercantum di atas',
      'Pembayaran dilakukan selambat-lambatnya 2(dua) hari setelah melakukan tes',
      'Hasil tes akan dikirimkan melalui email yang terdaftar pada transaksi selambatnya 3(tiga) hari kerja setelah pembayaran',
      'Transaksi dianggap batal apabila tanggal pembayaran melebihi ketentuan'
    ],
    uploadModalTitle: 'Upload Bukti Transfer',
    cancel: 'Batal',
    upload: 'Upload',
  },
  paymentPrompt: {
    proceedToPayment: 'Lanjutkan ke pembayaran ?',
    yes: 'Ya',
    no: 'Tidak',
  },
  paymentCheckout: {
    title: 'Checkout Pembayaran',
    saved: 'Transaksi Tersimpan',
    clickToPayment: 'Klik di bawah untuk melanjutkan ke pembayaran',
    processPayment: 'Proses Pembayaran',
  },
  paymentSuccess: {
    title: 'Pembayaran Berhasil!',
    message: 'Pembayaran Anda telah berhasil diproses. Anda akan menerima hasil tes melalui email dalam beberapa hari kerja.',
    backToTransactions: 'Kembali ke Transaksi',
  },
  paymentFailed: {
    title: 'Pembayaran Gagal',
    message: 'Pembayaran Anda tidak berhasil. Silakan coba lagi atau hubungi',
    customerService: 'customer service kami',
    backToTransactions: 'Kembali ke Transaksi',
  },
  paymentUnfinished: {
    title: 'Pembayaran Tertunda',
    message: 'Pembayaran Anda masih dalam proses. Mohon segera melengkapi pembayaran agar tes dapat diproses.',
    backToTransactions: 'Kembali ke Transaksi',
  },
  sessionExpired: 'Sesi Berakhir',
  sessionExpiredDesc: 'Sesi Anda telah berakhir. Silakan login kembali.',
  register: {
    title: 'Buat akun',
    step1Subtitle: 'Buat akun Anda untuk memulai asesmen',
    step2Subtitle: 'Siapkan kredensial login Anda',
  },
  loginModal: {
    title: 'Selamat datang di PRiADI',
    subtitle: 'Untuk pengalaman terbaik, silakan masuk atau daftar. Anda juga dapat melanjutkan sebagai tamu.',
  },
  months: {
    '01': 'Januari',
    '02': 'Februari',
    '03': 'Maret',
    '04': 'April',
    '05': 'Mei',
    '06': 'Juni',
    '07': 'Juli',
    '08': 'Agustus',
    '09': 'September',
    '10': 'Oktober',
    '11': 'Nopember',
    '12': 'Desember',
  },
}
